import { GridCellProps } from '@progress/kendo-react-grid';
import { useAppSelector } from '../../hooks/redux';
import { TagEditorEntity } from '../../models/tag.model';
import { selectTagRepository } from '../../store/slices/tag-editor.slice';
import { TagEditorList } from '../tags/TagEditorList';

export interface TagCellProps {
  dataItem: {
    [key: string]: any;
  };
}

export function TagCell({ dataItem, field }: GridCellProps) {
  const tags = dataItem[field ?? ''] ?? [];
  const tagRepo = useAppSelector(selectTagRepository);
  const objectTypeRepo = tagRepo[TagEditorEntity.RESPONSE] ?? {};
  const tagsFromRepository = objectTypeRepo[dataItem.responseId];
  return (
    <td className="k-table-td tag-cell">
      <div className="tag-editor">
        <TagEditorList
          objectType={TagEditorEntity.RESPONSE}
          id={dataItem.responseId}
          tags={tagsFromRepository ?? tags}
        />
      </div>
    </td>
  );
}
